import { ControlWidget } from 'angular2-schema-form';
import { Component } from '@angular/core';

@Component({
  selector: 'app-sf-column-widget',
  templateUrl: './column.widget.html'
})
export class MyColumnWidgetComponent extends ControlWidget {

}



// WEBPACK FOOTER //
// ./src/shared/form-widgets/column/column.widget.ts